import { styled } from "@mui/material/styles";

import { LabelValueSkeleton } from "../components/LabelValueSkeleton";
import { Wrapper } from "./ProductMetaLayoutComponents";

const ProductMetaWrapperSkeleton = styled(Wrapper)(({ theme }) => ({
    marginBottom: theme.spacing(4),
}));

export function ProductMetaSkeleton() {
    return (
        <ProductMetaWrapperSkeleton>
            <LabelValueSkeleton />
            <LabelValueSkeleton />
            <LabelValueSkeleton />
        </ProductMetaWrapperSkeleton>
    );
}
